// Функция для получения пустых данных формы
export const getEmptyFormData = () => ({
  data: [],
  itaks5: '', // Информация пользователя
  savedModalData: {}, // Сохраненные данные модального окна для каждой строки
  ochagPrichina: '', // Причина очага
  ochagVidVO: '', // Вид ВО очага
  ochagFaza: '', // Фаза очага
  ochagTip: '' // Тип очага
});

// Статические списки для выбора
export const FAZA_OPTIONS = [
  { value: 'начальная', label: 'начальная' },
  { value: 'нарастания численности', label: 'нарастания численности' },
  { value: 'собственно вспышка', label: 'собственно вспышка' },
  { value: 'кризис', label: 'кризис' },
  { value: 'возникающий', label: 'возникающий' },
  { value: 'действующий', label: 'действующий' },
  { value: 'затухающий', label: 'затухающий' }
];

export const TIP_OPTIONS = [
  { value: 'эпизодический', label: 'эпизодический' },
  { value: 'хронический', label: 'хронический' }
];

// Функции для преобразования между форматами
// EPISODIC <-> эпизодический
// CHRONIC <-> хронический
export const convertOchagTypeToForm = (ochagType) => {
  if (!ochagType) return '';
  if (ochagType === 'EPISODIC') return 'эпизодический';
  if (ochagType === 'CHRONIC') return 'хронический';
  // Если уже в русском формате, возвращаем как есть
  if (ochagType === 'эпизодический' || ochagType === 'хронический') {
    return ochagType;
  }
  return '';
};

export const convertOchagTypeFromForm = (formValue) => {
  if (!formValue) return null;
  if (formValue === 'эпизодический') return 'EPISODIC';
  if (formValue === 'хронический') return 'CHRONIC';
  // Если уже в английском формате, возвращаем как есть
  if (formValue === 'EPISODIC' || formValue === 'CHRONIC') {
    return formValue;
  }
  return null;
};

// Функции для преобразования фаз между форматами
// INITIAL -> начальная
// POPULATION_GROWTH -> нарастания численности
// OUTBREAK -> собственно вспышка
// CRISIS -> кризис
// EMERGING -> возникающий
// ACTIVE -> действующий
// FADING -> затухающий
export const convertOchagPhasaToForm = (ochagPhasa) => {
  if (!ochagPhasa) return '';
  const mapping = {
    'INITIAL': 'начальная',
    'POPULATION_GROWTH': 'нарастания численности',
    'OUTBREAK': 'собственно вспышка',
    'CRISIS': 'кризис',
    'EMERGING': 'возникающий',
    'ACTIVE': 'действующий',
    'FADING': 'затухающий'
  };
  // Если есть маппинг, возвращаем русское значение
  if (mapping[ochagPhasa]) {
    return mapping[ochagPhasa];
  }
  // Если уже в русском формате, возвращаем как есть
  if (Object.values(mapping).includes(ochagPhasa)) {
    return ochagPhasa;
  }
  return '';
};

export const convertOchagPhasaFromForm = (formValue) => {
  if (!formValue) return null;
  const mapping = {
    'начальная': 'INITIAL',
    'нарастания численности': 'POPULATION_GROWTH',
    'собственно вспышка': 'OUTBREAK',
    'кризис': 'CRISIS',
    'возникающий': 'EMERGING',
    'действующий': 'ACTIVE',
    'затухающий': 'FADING'
  };
  // Если есть маппинг, возвращаем английское значение
  if (mapping[formValue]) {
    return mapping[formValue];
  }
  // Если уже в английском формате, возвращаем как есть
  if (Object.values(mapping).includes(formValue)) {
    return formValue;
  }
  return null;
};

